import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";

export default class DialogAudioController {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SoundManager} soundManager 
     */
    constructor(dispatcher, soundManager) {
        this._dispatcher = dispatcher;
        this._soundManager = soundManager;

        /** @type {Map<number, AudioRegistration>} */
        this._audioByChannelIndex = new Map();
    }

    stopAllAudioChannels() {
        this._audioByChannelIndex.forEach((audioRegistration, channelIndex) => {
            this._stopAudioOnChannel(channelIndex);
        });
    }

    /**
     * Background audio is always looping, and always fades in.
     * @param {Object} params
     * @param {string} params.id 
     * @param {boolean} params.loop 
     * @param {number} params.channel 
     */
    playAudio({ id, loop = false, channel }) {
        if (channel !== undefined && channel !== null) {
            this._stopAudioOnChannel(channel);
        }

        console.log(`${DialogAudioController.name}: Playing ${id} in channel: ${channel}`);

        const loopValue = loop ? -1 : 0; // -1 = infinite loop, 0 = no loop
        const delay = 0;
        const offset = 0;
        const volume = 1;
        const pan = 0; // 0 = center, -1 = left, 1 = right
        const fadeInDuration = 1000;
        const soundId = this._soundManager.playSound(id, null, null, delay, offset, loopValue, volume, pan, fadeInDuration);

        if (channel !== undefined && channel !== null) {
            const audioRegistration = new AudioRegistration(id, soundId);
            this._audioByChannelIndex.set(channel, audioRegistration);
        }
    }

    _stopAudioOnChannel(channelIndex) {
        if (!this._audioByChannelIndex.has(channelIndex)) {
            // No audio is playing in channel.
            return;
        }

        
        const fadeOutDuration = 1000;
        const playingAudioRegistration = this._audioByChannelIndex.get(channelIndex);

        console.log(`${DialogAudioController.name}: Stopping audio in channel ${channelIndex}. File id: ${playingAudioRegistration.fileId}`);
        
        this._soundManager.stopSound(playingAudioRegistration.soundId, fadeOutDuration);
        this._audioByChannelIndex.delete(channelIndex);
    }
}

class AudioRegistration {
    constructor(fileId, soundId) {
        this.fileId = fileId;
        this.soundId = soundId;
    }
}